import md5 from 'js-md5'
import message from '@/pages/sea/reservation/official-site/components/message'
import { TOKEN_KEY, getToken } from '@/utils/cookie'
import { LnaLang } from '@/typings/common'

interface Data {
  [key: string]:
    | string
    | number
    | boolean
    | Data
    | Array<Data>
    | Array<string>
    | null
}

interface Response {
  code: number
  current_time: number
  data: any
}

interface ExtraParmas {
  [propsName: string]: any
}

const langMap = {
  [LnaLang.En]: 'en',
  [LnaLang.Es]: 'es',
  [LnaLang.Pt]: 'pt',
}

const request = (
  url: string,
  config: RequestInit & ExtraParmas = {}
): Promise<Response> => {
  const timestamp = Date.parse(`${new Date()}`) / 1000
  const key = 'de2d7b2864d3a6b88cb9318677c12f41'
  const sign = md5(`${timestamp}${key}`).toUpperCase()
  const realConfig: RequestInit & ExtraParmas = {
    headers: {
      timestamp: `${timestamp}`,
      sign,
      'content-type': 'application/json',
      language: langMap[localStorage.getItem('i18nextLng') as LnaLang] || 'en',
      Authorization: getToken(),
    },
    ...config,
  }

  return fetch(url, realConfig)
    .then((res: any) => res.json())
    .then((resJson: any) => {
      if (resJson.code !== 200 && resJson.code !== 0) {
        if (resJson?.message && !config?.extraParams?.forbid) {
          message.error({
            content: resJson?.message,
          })
        }
        throw resJson
      } else {
        return resJson
      }
    })
    .catch((err) => {
      if (!config?.extraParams?.forbid) {
        message.error({
          content: err?.message,
        })
      }
      if (err?.code === 401) {
        // 处理token失效
        // localStorage.removeItem(TOKEN_KEY)
        // window.location.reload()
      }
      console.error(err?.message)
      throw err
    })
}

// GET请求
export const get = (
  url: string,
  data: Data = {},
  extraParams?: ExtraParmas
): Promise<Response> => {
  const keysArray = Object.keys(data)
  if (keysArray.length > 0) {
    url += '?'
    url += keysArray.map((key) => `${key}=${data[key]}`).join('&')
  }
  return request(url, { method: 'GET', extraParams })
}

// POST请求
export const post = (
  url: string,
  data: Data = {},
  extraParams?: ExtraParmas
): Promise<Response> => {
  return request(url, {
    body: JSON.stringify(data),
    method: 'POST',
    extraParams,
  })
}
